import React from 'react';
import './NotificationPopup.css';

const NotificationPopup = ({ message, type, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className={`notification-popup ${type}`}>
      <div className="notification-content">
        <p>{message}</p>
      </div>
    </div>
  );
};

export default NotificationPopup; 